import { Controller } from "stimulus"
import axios from "axios";

export default class extends Controller {
  static targets = ['input', 'hidden', 'dentalPlanSelect', 'priceInput']

  connect() {
    let selected = null
    let $typeahead = $(this.inputTarget).typeahead(
      {},
      {
        display: 'name',
        limit: 25,
        source:  _.debounce((query, syncResults, asyncResults) => {
            axios.get(this.data.get('url'), {
                params: {
                  term: query,
                  dental_plan_id: this.dentalPlanSelectTarget.value
                }
            }).then((response) => {
              asyncResults(response.data)
            });
        }, 200),
      }
    ).bind('typeahead:select typeahead:autocomplete', (e, data) => {
      selected = data
      $(this.hiddenTarget).val(data.id)
      $(this.priceInputTarget).val(data.price)
      this.priceInputTarget.dispatchEvent(new Event('change'))
      // reset the validations because if a validation in the price failed before
      // wont let submit because doesn't detect that the price was set
      $(this.element).resetClientSideValidations();
    }).bind('typeahead:change', (e, term) => {
      if (!selected || selected.name != term) {
        $typeahead.typeahead('val', '');
        // we need to do this, otherways the client side validation for the
        // typeahead input wont work
        $(this.element).resetClientSideValidations();
        $(this.hiddenTarget).val('');
        $(this.priceInputTarget).val('');
        selected = null
      }
    })
  }

  teardown() {
    $('.tt-input').typeahead('destroy')
  }
}
